import { StyleSheet, View } from 'react-native';

import {
  GOOGLE_PAY_MARK_OFFSET,
  GOOGLE_PAY_MARK_SIZE,
  GOOGLE_PAY_MARK_WIDTH,
  IconChevronRight,
  Skeleton,
  XStack,
  tokens,
} from '@fhs/ui';

/** Row layout shared with the loaded payment Pressable in index.tsx */
export const paymentMethodRowStyles = StyleSheet.create({
  anchor: {
    marginHorizontal: 28,
  },
  container: {
    width: '100%',
    borderColor: tokens.colors.$black10,
    backgroundColor: tokens.colors.$white,
    borderWidth: StyleSheet.hairlineWidth,
    borderRadius: 8,
    gap: 8,
    padding: 16,
  },
  cardContainer: {
    gap: 8,
    alignItems: 'center',
  },
  textContainer: {
    flex: 1,
    minWidth: 0,
    alignItems: 'flex-start',
    justifyContent: 'center',
  },
  iconSlot: {
    height: GOOGLE_PAY_MARK_SIZE,
    width: GOOGLE_PAY_MARK_WIDTH,
    justifyContent: 'center',
    alignItems: 'center',
    marginLeft: GOOGLE_PAY_MARK_OFFSET,
    marginRight: GOOGLE_PAY_MARK_OFFSET,
    flexShrink: 0,
  },
  iconCircle: {
    height: 40,
    width: 40,
    borderRadius: 40,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: tokens.colors.$houseLight,
    flexShrink: 0,
  },
});

const skeletonStyles = StyleSheet.create({
  iconSkeleton: {
    height: 40,
    width: 40,
    borderRadius: 40,
    flexShrink: 0,
  },
  labelSkeleton: {
    height: 20,
    width: 96,
    borderRadius: 4,
    flexShrink: 0,
  },
});

export default function PaymentMethodLoadingSkeleton() {
  return (
    <View style={paymentMethodRowStyles.anchor}>
      <View style={paymentMethodRowStyles.container}>
        <XStack style={paymentMethodRowStyles.cardContainer}>
          <Skeleton style={skeletonStyles.iconSkeleton} />
          <View style={paymentMethodRowStyles.textContainer}>
            <Skeleton style={skeletonStyles.labelSkeleton} />
          </View>
          <IconChevronRight size={24} color={tokens.colors.$houseDark} />
        </XStack>
      </View>
    </View>
  );
}
